import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import NavDropdown from "react-bootstrap/NavDropdown";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Dropdown from 'react-bootstrap/Dropdown';
import Button from 'react-bootstrap/Button';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Row, Col } from "react-bootstrap";

// import { config } from "assets/config";
import {
  changeActiveSection,
  changeActiveGroup,
  changeMaxActiveGroup,
} from "redux/userInfo";

import "./index.scss";
import { ReactComponent as Check } from "../../assets/images/Check.svg";
import { clearValidateTriggered, setIsToggled } from "redux/formDisplay";
import {
  clearRecursiveFormData,
  clearSaveData,
  clearShowData,
  setSaveData,
  setShowDataPreview,
  setShowRecursiveForm,
  setIsSignerRecursion
} from "redux/recursiveReducer";
// import { IndirectEval } from "helper/indirectEval";
import { clearFieldRecursionData } from "redux/fieldRecursiveReducer";
import { log } from "@craco/craco/lib/logger";



const FormStepper = (props) => {
  const { config, consent = false, isMobile, setFormErr, formErr, validateAndSubmit,nav_orientation } = props;

  const activeGroup = useSelector((state) => state.userInfo.activeGroup);
  const activeSection = useSelector((state) => state.userInfo.activeSection);
  const maxActiveGroup = useSelector((state) => state.userInfo.maxActiveGroup);
  const maxActiveSection = useSelector(
    (state) => state.userInfo.maxActiveSection
  );
  const primaryUser = useSelector((state) => state.userInfo?.primaryUser);
  const workflowUser = useSelector((state) => state.userInfo?.workflowUser);
  const selectedData = useSelector((state) => state.formData?.selectedData);
  const restricted_ = useSelector((state) => state?.formData?.restricted_view);
  const showDataPreview = useSelector(
    (state) => state.recursive?.showDataPreview
  );
  const displayStepper = useSelector(
    (state) => state.stepperReducer?.stepperDisplay
  );

  const stepperSections = useSelector(
    (state) => state.stepperReducer?.sections
  );

  const banner = useSelector((state) => state?.stepperReducer?.banner);
  const requestedDocs = useSelector(
    (state) => state?.requestedDocReducer?.requestedDocs
  );
  // let formStructure = {}, sections = {}
  const dispatch = useDispatch();
  const IndirectEval = (evalString) => {
    // const selectedData = useSelector((state)=>state.formData.selectedData)
    return eval(evalString);
  };

  const [clickedId, setClickedId] = useState();
  const [currentName, setCurrentName] = useState();
  const [ currentGroup,setcurrentGroup] = useState();
  let activeStepOrder = 1;

  useEffect(() => {
    setCurrentName(maxActiveGroup);
    Object.keys(stepperSections).forEach(([key, value], index) => {
      if (key == maxActiveSection + 1) {
        setcurrentGroup(
          stepperSections[index]?.form_groups.findIndex((element) => {
            if (element.group_order == maxActiveGroup) {    
              setCurrentName(element.title);
            }
          })
        );
      }
    });
  }, [stepperSections]);
  
  useEffect(() => {
    setClickedId(maxActiveSection);
  }, []);

  useEffect(() => {
    setClickedId(maxActiveSection);
  }, [maxActiveSection]);

  const handleSectionClick = (section_order) => {
    if (section_order > activeSection) {
      let errors = validateAndSubmit()
      if (errors && Object.keys(errors).length > 0) return
    }
    if (
      stepperSections[maxActiveSection]?.element_number >
      stepperSections[section_order]?.element_number
    ) {
      dispatch(changeActiveSection(section_order));
      dispatch(changeActiveGroup(1));
      dispatch(clearValidateTriggered()); // To clear the validation error when the user clicks on back button or page refresh or next button

      // dispatch(changeActiveGroup(0))
      setClickedId(section_order);
    } else if (
      stepperSections[maxActiveSection]?.element_number ===
      stepperSections[section_order]?.element_number
    ) {
      dispatch(changeActiveSection(section_order));
      dispatch(changeActiveGroup(1));
      dispatch(clearValidateTriggered()); // To clear the validation error when the user clicks on back button or page refresh or next button

      setClickedId(section_order);
    }
    dispatch(setIsSignerRecursion(false))
  };

  const handleListClick = (index, activeIndex, clickedSubStep,name) => {
    if (index <= clickedSubStep) {
      if (clickedSubStep === activeGroup) return;
      if (clickedSubStep > activeGroup || activeSection < maxActiveSection) {
        let errors = validateAndSubmit()
        if (errors && Object.keys(errors).length > 0) return
      }
      dispatch(changeActiveGroup(clickedSubStep));
      setCurrentName(name);
      setFormErr({})
      dispatch(clearValidateTriggered()); // To clear the validation error when the user clicks on back button or page refresh or next button

      //Disabling the toggle copy to enable editing of the fields
      dispatch(setIsToggled(false));
      // if (showDataPreview) {
      dispatch(setShowRecursiveForm(false));
      dispatch(setShowDataPreview(false));
      dispatch(clearSaveData());
      dispatch(clearShowData());
      dispatch(clearRecursiveFormData());
      dispatch(setIsSignerRecursion(false))
      // }
      // dispatch(clearFieldRecursionData());
    }
  };

  //from the url check the query params for requestedId
  const search = window.location.search;
  const query = new URLSearchParams(search);
  const requestedId = useMemo(() => {
    return query.get("requestedId");
  }, [search]);

  // if (!Object.keys(primaryUser).length) return "Loading..."

  //Offcanvas
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      {displayStepper ? (
    <>
     <div>
    <div className="d-none d-md-block form-container-height overflow-y-scroll no-scrollbar pe-lg-0 m-lg-0 p-1">
    {Object.entries(stepperSections).map((item) => {
                    let index = parseInt(item[0]);
                    item = item[1];
                    const { section_order, title, display_section } = item;
                    return (
                      display_section &&
                      IndirectEval(display_section) && (
                        <div className="form-stepper-container" key={index}>
                          {
                            <div className="first-row">
                              <button
                                className="step-btn"
                                onClick={() =>
                                  handleSectionClick(section_order)
                                }
                                disabled={(requestedId || stepperSections[section_order].form_groups.find((group) => {
                                  return group.name === "otp_verification"
                                })) ? true : maxActiveSection < section_order}
                              >
                                <div
                                  className={`circle-container ${section_order === maxActiveSection
                                      ? "circle-dot"
                                      : stepperSections[maxActiveSection]
                                        ?.element_number > index
                                        ? "circle-tick"
                                        : "circle border rounded-5 bg-dark"
                                    }`}
                                >
                                  {section_order == maxActiveSection ? (
                                    <div></div>
                                  ) : maxActiveSection > index ? (
                                    <Check />
                                  ) : (
                                    <div></div>
                                  )}
                                </div>
                                <span className="btn-title">{title}</span>
                              </button>
                            </div>
                          }
                            <div className="second-row">
                          {section_order === activeSection ? (
                            <ul>
                              {item?.form_groups &&
                                item?.form_groups?.length &&
                                item?.form_groups?.map((_item, _index) => {
                                  const { display_group, group_order } = _item;
                                  let activeIndex = stepperSections[maxActiveSection]?.form_groups?.findIndex(
                                    (element) =>
                                      element.group_order == maxActiveGroup
                                  );
                                  if (IndirectEval(display_group)) {
                                    return (
                                      <li
                                        key={_index}
                                        className={
                                          ((((!requestedId ) && (_index <= activeIndex ||
                                            index + 1 <= maxActiveSection)) && ( stepperSections[activeSection]?.form_groups?.[activeGroup-1]?.name !== "otp_verification"))|| (requestedId && (activeGroup === group_order)))
                                            ? "highlight pe-auto"
                                            : "pe-none"
                                        } 
                                        onClick={() =>
                                          handleListClick(
                                            _index,
                                            maxActiveGroup,
                                            group_order,
                                            _item.title
                                          )
                                        }
                                      >
                                        <span className={_index + 1 == activeGroup && "group_highlight"}>
                                          {_item.title}
                                        </span>
                                        {/* {_item.title} */}
                                      </li>
                                    );
                                  }
                                })}
                            </ul>
                          ) : index !== stepperSections.length - 1 ? (
                            <div
                              className={`empty-div ${index < maxActiveGroup ? "highlight" : "null"
                                }`}
                            ></div>
                          ) : null}
                        </div>
                        </div>
                      )
                    );
                  })}
    </div>
     </div>
    <>  

<Dropdown.Toggle onClick={handleShow} className="me-2 d-lg-none d-md-none bg-transparent text-dark border-0 p-0">
              {currentName}
              <span className="m-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
  <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
</svg>
                </span> </Dropdown.Toggle>  
              {/* <ProgressBar className="progress progress-sm w-100 h-5px d-lg-none d-md-none" now={25}></ProgressBar> */}
            <Offcanvas show={show} onHide={handleClose} placement="end" className=" h-100">
              <Offcanvas.Header closeButton>
                <Offcanvas.Title
                className="fw-bold fs-20px text-theme"
                >Form Details</Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                {Object.entries(stepperSections).map((item) => {
                  let index = parseInt(item[0]);

                  item = item[1];
                  const { section_order, title, display_section, restricted_view } = item;
                  let restrict = restricted_view ? restricted_ : false
                  return (
                    display_section &&
                    IndirectEval(display_section) && (
                      <div className="form-stepper-container " key={index}>
                        {
                          <div className="first-row">
                            <button
                              className="step-btn"
                              onClick={() => handleSectionClick(section_order)}
                              disabled={requestedId ? true : maxActiveSection < section_order || restrict}
                            >
                              <div
                                className={`circle-container ${section_order === maxActiveSection
                                    ? "circle-dot"
                                    : stepperSections[maxActiveSection]
                                      ?.element_number >= index
                                      ? "circle-tick"
                                      : "circle"
                                  }`}
                              >
                                {section_order === maxActiveSection ? (
                                  <div></div>
                                ) : maxActiveSection > index ? (
                                  <Check />
                                ) : (
                                  <div></div>
                                )}
                              </div>
                              <span className="btn-title">{title}</span>
                            </button>
                          </div>
                        }
                        <div className="second-row">
                          {section_order === activeSection ? (
                            <ul>
                              {item?.form_groups &&
                                item?.form_groups?.length &&
                                item?.form_groups?.map((_item, _index) => {
                                  const { display_group, group_order } = _item;
                                  let activeIndex = stepperSections[
                                    maxActiveSection
                                  ]?.form_groups?.findIndex(
                                    (element) =>
                                      element.group_order == maxActiveGroup
                                  );
  
                                  if (IndirectEval(display_group)) {
                                    return (
                                      <li
                                        key={_index}
                                        className={
                                          (!requestedId || _index + 1 === activeIndex) && (_index <= activeIndex ||
                                            index + 1 <= maxActiveSection)
                                            ? "highlight pe-auto"
                                            : "pe-none"
                                        }
                                        onClick={() =>
                                          handleListClick(
                                            _index,
                                            maxActiveGroup,
                                            group_order,
                                            _item.title
                                          )
                                        }
                                      >
                                        <span className={_index + 1 == activeGroup && "group_highlight"}>
                                          {_item.title}
                                        </span>
                                        {/* {_item.title} */}
                                      </li>
                                    );
                                  }
                                })}
                            </ul>
                          ) : index !== stepperSections.length - 1 ? (
                            <div
                              className={`empty-div ${index < maxActiveGroup ? "highlight" : "null"
                                }`}
                            ></div>
                          ) : null}
                        </div>
                      </div>
                    )
                  );
                })}
              </Offcanvas.Body>
            </Offcanvas>
            </>
          
      </>

     ) : (
        <div className={`client-type ${nav_orientation === 'horizontal' ? 'form-container-height':''}`}>
          {banner?.map((item, index) => {
            if (IndirectEval(item.show))
              return (
                <div
                  className={`client-type-inner ${nav_orientation === 'horizontal' ? '':'text-center'}`}
                  key={index}
                  dangerouslySetInnerHTML={{ __html: item.content }}
                // style={{"width" : item?.occupancy}}
                />
              );
          })}
        </div>
      )}
    </>
  );
};

export default FormStepper;
